import { Link } from "react-router-dom";
export const Logo = () => <Link to="/" className="flex items-center">
    <img alt="Offertio" className="h-8 w-auto object-contain" src="/lovable-uploads/d93ad91c-ec70-4c48-96ae-68c869dd1ed2.png" />
  </Link>;